const Blog = {
    state: {
        blogPerPage: 12,
        visibleCount: 0,
        category: 'alls',
        sort: 'newest',
        data: []
    },

    utils: {
        formatDate(createdAt) {
            if (!Array.isArray(createdAt)) return '';

            const day = createdAt[3];
            const month = createdAt[4];
            const year = createdAt[5];

            return new Intl.DateTimeFormat('en-US', {
                month: 'long',
                day: '2-digit',
                year: 'numeric'
            }).format(
                new Date(year, month - 1, day)
            );
        },

        getTimestamp(createdAt) {
            if (!Array.isArray(createdAt)) return 0;

            const day = createdAt[3];
            const month = createdAt[4];
            const year = createdAt[5];

            return new Date(
                year,
                month - 1,
                day
            ).getTime();
        }
    },

    templates: {
        featured(item) {
            const time = Blog.utils.formatDate(item.created_at);

            const author = item.author?.name ?? item.author;

            const words = author.split(" ")
                .slice(0, 2)
                .map(word => word[0])
                .join("");


            return `
                <a class="bl-feature" href="${item.url}" style="display: grid;">
                    <div class="bl-feature__visual">
                        <img 
                            src="${item.image?.src || _logo}" 
                            srcset="${item.image.srcset}"
                            sizes="(min-width:1024px) 33vw, 100vw"
                            alt="${item.image?.alt || item.title}" 
                            width="${item.image?.width || ''}"
                            height="${item.image?.height || ''}"
                            class="w-full h-full block object-cover object-left"
                        />
                    </div>

                    <div class="bl-feature__copy">
                        <span class="bl-feature__eyebrow">
                            <span class="pill">Featured · this week</span>

                            <span class="bl-feature__meta">
                                ${item.blog_title} <span class="bl-feature__dot" aria-hidden="true"></span>
                                ${time} <span class="bl-feature__dot" aria-hidden="true"></span>
                                <!-- 9 min read -->
                            </span>
                        </span>

                        <h2 class="bl-feature__title"> ${item.title} </h2>

                        <p class="bl-feature__lede"> ${item.summary} </p>

                        <div class="bl-feature__byline">
                            <span class="bl-feature__avatar" aria-hidden="true">
                                ${words}
                            </span>
                            <span class="bl-feature__byline-text">
                                <strong>${author}</strong>
                                <!-- <small>Experimentation lead</small> -->
                            </span>
                        </div>
                        
                        <span class="bl-feature__read">
                            Read the post 
                            <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width: 12px; height: 12px;">
                                <path d="M2 6h8"></path>
                                <path d="M7 3l3 3-3 3"></path>
                            </svg>
                        </span>
                    </div>
                </a>
            `;
        },

        card(item) {
            const time = Blog.utils.formatDate(item.created_at);

            const author = item.author?.name ?? item.author;

            const words = author.split(" ")
                .slice(0, 2)
                .map(word => word[0])
                .join("");

            return `
                <div class="bl-card">
                    <div class="bl-card__visual">
                        <a href="/blogs/${item.blog_handle}" class="bl-card__category"> ${item.blog_title} </a>

                        <a href="${item.url}" class="block h-full">
                            <img 
                                src="${item.image?.src || _logo}" 
                                srcset="${item.image.srcset}"
                                sizes="(min-width:1024px) 33vw, 100vw"
                                loading="lazy"
                                alt="${item.image?.alt || item.title}" 
                                width="${item.image?.width || ''}"
                                height="${item.image?.height || ''}"
                                class="${item.image?.src ? 'w-full h-full block object-cover object-top' : 'fit-img'}"
                            />
                        </a>
                    </div>

                    <div class="bl-card__body">
                        <a href="${item.url}">
                            <h3 class="bl-card__title"> ${item.title} </h3>
                        </a>

                        <p class="bl-card__excerpt"> ${item.summary} </p>

                        <div class="bl-card__foot">
                            <div class="bl-card__byline">
                                <span class="bl-card__avatar" aria-hidden="true">
                                    ${words}
                                </span>
                                <span class="bl-card__author"> ${author} </span>
                            </div>
                            <span class="bl-card__meta"> ${time} </span>
                        </div>
                    </div>
                </div>
            `;
        },

        collection(item) {
            const time = Blog.utils.formatDate(item.created_at);

            return `
                <div class="bl-deep__item">
                    <a href="${item.url}" class="bl-deep__thumb">
                        <img 
                            src="${item.image?.src || _logo}" 
                            srcset="${item.image.srcset}"
                            sizes="(min-width:1024px) 33vw, 100vw"
                            loading="lazy"
                            alt="${item.image?.alt || item.title}" 
                            width="${item.image?.width || ''}"
                            height="${item.image?.height || ''}"
                            class="${item.image?.src ? 'w-full h-full block object-cover object-top' : 'fit-img'}"
                        />
                    </a>

                    <div class="bl-deep__body">
                        <a href="/blogs/${item.blog_handle}" class="bl-deep__cat"> ${item.blog_title} </a>
                        <a href="${item.url}">
                            <h4 class="bl-deep__title"> ${item.title} </h4>
                        </a>
                        <span class="bl-deep__meta"> ${time} </span>
                    </div>
                </div>
            `
        }
    },

    service: {
        getData() {
            let data = [...Blog.state.data];

            if (Blog.state.category !== 'alls') {
                data = data.filter(
                    item => item.blog_handle === Blog.state.category
                );
            }

            switch (Blog.state.sort) {
                case 'newest':
                    data.sort(
                        (a, b) =>
                            Blog.utils.getTimestamp(b.created_at) -
                            Blog.utils.getTimestamp(a.created_at)
                    );
                    break;

                case 'az':
                    data.sort((a, b) =>
                        a.title.localeCompare(b.title)
                    );
                    break;

                case 'za':
                    data.sort((a, b) =>
                        b.title.localeCompare(a.title)
                    );
                    break;
            }

            return data;
        },

        getFeatured() {
            return Blog.state.data.find(item =>
                item.tags?.some(
                    tag => tag.toLowerCase() === 'featured'
                )
            );
        },

        getCollection() {
            return Blog.state.data.filter(item =>
                item.tags.some(tag => tag.toLowerCase() === 'collection')
            );
        },

        getVisibleData(data) {
            return data.slice(
                0,
                Blog.state.blogPerPage
            );
        }
    },

    ui: {
        renderList(data) {
            const target = document.getElementById('js-article-list');

            if (!target) return;

            target.innerHTML = data.map(Blog.templates.card).join('');
        },

        renderFeatured() {
            const target = document.getElementById('js-featured-blog');

            if (!target) return;

            const featured = Blog.service.getFeatured();

            target.innerHTML = featured ? Blog.templates.featured(featured) : '';
        },

        renderCollection() {
            const target = document.getElementById('js-collection-list');

            if (!target) return;

            const collection = Blog.service.getCollection();

            if (collection && collection.length > 0) {

                target.innerHTML = collection.map(Blog.templates.collection).join('');

                document.getElementById('js-collection-container').classList.remove('hidden')
            }
        },

        renderCounter(data) {
            const target = document.getElementById('js-article-counter');

            if (!target) return;
            const count = data.length;
            const label = count === 1 ? 'post' : 'posts';

            target.innerHTML = `<strong>${count}</strong> ${label}`;
        },

        renderCategories() {
            const target = document.getElementById('js-btn-cat');

            if (!target) return;

            target.innerHTML = blogCategories.map(item => {

                const count =
                    item.handle === 'alls'
                        ? Blog.state.data.length
                        : Blog.state.data.filter(
                            article => article.blog_handle === item.handle
                        ).length;

                const isActive = Blog.state.category === item.handle ? 'is-active' : '';

                const icon = item.handle === 'alls' ? '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"> <rect x="2" y="2" width="5" height="5" rx="1"></rect> <rect x="9" y="2" width="5" height="5" rx="1"></rect> <rect x="2" y="9" width="5" height="5" rx="1"></rect> <rect x="9" y="9" width="5" height="5" rx="1"></rect> </svg>' : '';

                return `
                    <button
                        class="js-btn-cat bl-cat ${isActive}"
                        data-handle="${item.handle}"
                    >
                        ${icon}
                        <span>${item.handle === 'alls' ? 'All' : item.title}</span>
                        <span class="bl-cat__count">${count}</span>
                    </button>
                `;
            }).join('');
        },

        renderLoadMore(total, visible) {

            const target = document.getElementById('js-load-more');

            if (!target) return;

            if (visible >= total) {
                target.innerHTML = '';
                return;
            }

            target.innerHTML = `
                <button class="js-load-more btn btn--primary my-5">
                    Show more 
                    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8h10"></path><path d="M9 4l4 4-4 4"></path></svg>
                </button>
            `;
        }
    },

    events: {
        init() {
            document.addEventListener('click', Blog.events.onClick);

            Blog.events.onSort();
        },

        onClick(e) {

            const categoryBtn = e.target.closest('.js-btn-cat');

            if (categoryBtn) {
                Blog.handleCategory(categoryBtn);
                return;
            }

            const loadMoreBtn = e.target.closest('.js-load-more');

            if (loadMoreBtn) {
                Blog.handleLoadMore();
            }
        },

        onSort() {
            const select = document.getElementById('js-sort-article');

            if (!select) return;

            select.addEventListener('change', e => {

                Blog.state.sort = e.target.value;

                Blog.render();
            });
        }
    },

    handleLoadMore() {
        Blog.state.visibleCount += Blog.state.blogPerPage;
        Blog.render();
    },

    handleCategory(btn) {
        Blog.state.category = btn.dataset.handle;

        Blog.state.visibleCount = 0; // reset pagination

        Blog.render();
    },

    render() {

        const { service, ui, state } = Blog;

        const data = service.getData();

        // State
        if (state.visibleCount === 0) {
            state.visibleCount = state.blogPerPage;
        }

        const visibleData = data.slice(0, state.visibleCount);

        // UI
        ui.renderList(visibleData);

        ui.renderCounter(data);

        ui.renderCategories();

        ui.renderLoadMore(data.length, visibleData.length);
    },

    init() {
        Blog.state.data = [...blogData];

        this.events.init();

        this.render();

        Blog.ui.renderFeatured();

        Blog.ui.renderCollection();

        document.getElementById('js-total-article').innerHTML = `
            <strong> ${blogData.length} </strong> post${blogData.length === 1 ? '' : 's'}
        `;
    }
};

document.addEventListener('DOMContentLoaded', () => {
    Blog.init();
});